module.exports = __webpack_public_path__ + "res/0-img_players.e90ad608d660ee830c8ea5b5725cbd11.png";